import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { ExpandMore as ExpandMoreBase } from '@mui/icons-material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    border-bottom: 4px solid ${props => props.theme.palette.blue[35]};
    margin-bottom: 115px;
    padding-right: 0;
    position: relative;
    width: 100%;

    ${props => props.theme.breakpoints.down('sm')} {
      padding-right: 24px;
    }

    ${props => props.theme.breakpoints.down('xs')} {
      padding-right: 16px;
    }
  }
`

export const GridContainer = styled(({ height, margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const ErrorMessage = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  line-height: 26px;
  margin: 0 0 17px;
  max-width: 476px;
  text-align: center;
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: normal;
  line-height: 38px;
  margin: 0;
  margin-right: -200px;
  width: 610px;
  padding: 0;
  position: relative;
  z-index: 3;

  & span {
    background-color: ${props => props.theme.palette.brand.white};
  }

  ${props => props.theme.breakpoints.down('sm')} {
    margin-right: 0;
    text-align: center;
    width: auto;
  }
`

export const Strong = styled('strong')``

export const BannerContainer = styled('div')`
  display: flex;
  justify-content: center;
  height: 580px;
  padding: 0;

  ${props => props.theme.breakpoints.down('sm')} {
    height: initial;
  }
`

export const BannerImageContainer = styled('div')`
  width: 60%;
  height: 100%;
  position: absolute;
  right: 0;

  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1;
    height: 80px;
    background: linear-gradient(0deg, ${props => props.theme.palette.custom.gradientBlack}, transparent);

    ${props => props.theme.breakpoints.down('sm')} {
      display: none;
    }
  }
`

export const BannerInfo = styled('div')`
  width: 42%;
  background-color: ${props => props.theme.palette.brand.white};
  height: 100%;
  position: relative;
  z-index: 3;

  ${props => props.theme.breakpoints.down('sm')} {
    width: 100%;
  }
`

export const BannerInfoContainer = styled('div')`
  max-width: 1280px;
  width: 100%;
`

export const BannerImage = styled('img')`
  align-items: flex-end;
  box-sizing: border-box;
  height: 100%;
  position: relative;
  width: 100%;
  object-fit: cover;

  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`

export const BannerText = styled('span')`
  color: ${props => props.theme.palette.brand.white};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  line-height: 20px;
  z-index: 2;
  position: absolute;
  bottom: 6px;
  right: 10px;

  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`

export const AnchorRegion = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.gray3};
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  max-width: 414px;
  min-height: 50px;
  min-width: 100px;
  padding: 17px 21px;
  width: 100%;

  ${props => props.theme.breakpoints.down('sm')} {
    max-width: 100%;
  }
`

export const AnchorRegionLabel = styled('div')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 1.1px;
  line-height: 14px;
  padding: 0 0 4px;
  text-transform: uppercase;
`

export const AnchorRegionText = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 1.5;
  pointer-events: none;
  margin: 0 16px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
`

export const AnchorRegionIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.primary};
    font-size: 1.6em;
    line-height: 1;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const AnchorYear = styled('div')`
  border-bottom: 2px solid ${props => props.theme.palette.brand.black1};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`

export const AnchorYearLabel = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 16px;
`

export const AnchorYearText = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 1.5;
  pointer-events: none;
  margin: 0 12px 0 0;
  user-select: none;
`

export const AnchorYearIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black1};
    font-size: 20px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const Datum = styled('div')`
  height: 100%;
  width: 100%;
`

export const Value = styled('div')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 22px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Label = styled(({ margin, ...props }) => <div {...props} />)`
  color: ${props => props.theme.palette.brand.black2};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  line-height: 20px;
  margin: ${props => props.margin};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Action = styled(({ margin, ...props }) => <div {...props} />)`
  color: ${props => props.theme.palette.brand.black3};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  margin: ${props => props.margin};

  &:hover {
    color: ${props => props.theme.palette.brand.black2};
  }
`

export const ActionLink = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: auto;
  justify-content: center;
  margin: 0 8px 0 0;

  &:hover > *,
  &:hover .MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.black2};
    fill: ${props => props.theme.palette.brand.black2};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    height: 20px;
  }
`

export const HelpIcon = styled('span')`
  align-items: center;
  border: 1px solid ${props => props.theme.palette.brand.black3};
  border-radius: 50%;
  box-sizing: border-box;
  color: ${props => props.theme.palette.brand.black3};
  font-size: 14px;
  font-weight: bold;
  display: flex;
  height: 20px;
  justify-content: center;
  margin-right: 8px;
  padding: 9px;
  width: 20px;
`
